import Wrapper from "../components/Wrapper"
import { reviews } from "../Data";

function ReviewPage() {
    let elements = [];
    reviews.forEach((review_obj) => {
        elements.push(
        <div style={{color: "white", width: "100%"}}>
            <p>
                "{review_obj.content}"
            </p>
            <p>- {review_obj.reviewer}</p>
            <hr style={{color: "white", width: "100%"}}/>
        </div>
        );
    });
    return (
        <div>
            <Wrapper title={ "Reviews" }>
                {elements}
            </Wrapper>
        </div>
    )
}

export default ReviewPage;
